import { SpwkUtilV3 } from "../dao/SpwkUtilV3";
import { new_ErrorAlert } from "./ExportManager";
import { GovRow } from "./GovRow";
import { SpwkGovStep } from "./GovRowHelper";
import { HisBasic } from "./HisBasic";
import { SpwkMetaData } from "./SpwkMetaData";
import { SpwkMetaTable } from "./SpwkMetaTable";

export class GovRowParser_既往病史_自覺症狀 {// 問卷類別3: 既往病史、問卷類別5: 自覺症狀

  static ConvertToHisRow(step: SpwkGovStep, 基本檔: HisBasic, meta_table: SpwkMetaTable): GovRow[] {

    if (step.Chapter === SpwkUtilV3.CHAPTER_既往病史 || step.Chapter === SpwkUtilV3.CHAPTER_自覺症狀) {
      // pass;
    } else {
      throw new Error("必須是 既往病史 或 自覺症狀 !!!");
    }

    let re: GovRow[] = [];

    let q_meta_list = meta_table.FilterQuestions_ByChapter(step.Chapter);

    for (const q_meta of q_meta_list) {
      const gov_row: GovRow = 申報通用解碼(q_meta, 基本檔, step, meta_table);

      re.push(gov_row);
    }


    return re;
  }

}


export function 申報通用解碼(q_meta: SpwkMetaData, 基本檔: HisBasic, step: SpwkGovStep, meta_table: SpwkMetaTable): GovRow {
  const gov_row: GovRow = new GovRow(基本檔, step.Gov問卷類別);

  gov_row.問題編號 = q_meta.q_gov_code;

  /* 填寫勾選 OneHot 格式 */
  let opt_meta_list = meta_table.FilterOptions_ByQuestionGuid(q_meta.question_guid);
  let one_hot_value = ConvertToOneHotFormat(q_meta, opt_meta_list);
  gov_row.答題內容 = one_hot_value; // "010010"


  /* 填寫 TextBox */
  填寫申報文字答題1到4(gov_row, q_meta, meta_table);
  return gov_row;
}

export function 填寫申報文字答題1到4(gov_row: GovRow, q_meta: SpwkMetaData, meta_table: SpwkMetaTable) {

  let input_meta_list: SpwkMetaData[] = [];
  if (q_meta.kind === SpwkUtilV3.Q_KIND_多選 || q_meta.kind === SpwkUtilV3.Q_KIND_非選) {

    input_meta_list = meta_table.FilterInputs_ByQuestionGuid(q_meta.question_guid);

  } else if (q_meta.kind === SpwkUtilV3.Q_KIND_單選) {

    let find_opt_meta = meta_table.FindRadioOptionMeta(q_meta);

    if (find_opt_meta != null) {
      input_meta_list = meta_table.FilterInputs_ByOptionGuid(find_opt_meta.data_guid);

    } else {
      if (q_meta.rhf_value == null || q_meta.rhf_value === "") {
        input_meta_list = [];// pass 尚未勾選
      } else {
        throw new_ErrorAlert("66514648 找不到 opt_meta !!!\nq_meta.data_guid= " + q_meta.data_guid + "\n" + q_meta.getDebugDisplayCode());
      }
    }

  } else {
    throw new_ErrorAlert("1465432 必須是單選 或 多選 !!!\nq_meta.data_guid: " + q_meta.data_guid + "\n" + q_meta.getDebugDisplayCode());
  }



  for (const inp_meta of input_meta_list) {
    let n = parseInt(inp_meta.i_gov_code);
    if (isNaN(n)) {
      throw new_ErrorAlert("4341686 申報選項必須有 o_gov_code 且為數字 !!!\n題目: q_meta:" + q_meta.getDebugDisplayCode() + "\ninp_meta.data_guid: " + inp_meta.data_guid);
    }

    let rhf_value = inp_meta.rhf_value ?? "";
    rhf_value = rhf_value.replace(/,/g, '，');
    if (n === 1) {
      if (gov_row.答題內容_1) {//yao 90~94 159~184
        gov_row.答題內容_2 = rhf_value
      } else {
        gov_row.答題內容_1 = rhf_value;
      }
    } else if (n === 2) {
      gov_row.答題內容_2 = rhf_value;
    } else if (n === 3) {
      gov_row.答題內容_3 = rhf_value;
    } else if (n === 4) {
      gov_row.答題內容_4 = rhf_value;
    } else {
      throw new_ErrorAlert("494916 答題內容_1~4 index超出範圍 !!!\ninp_meta.data_guid: " + inp_meta.data_guid);
    }

  }




}

// 一整題的選項會被合併為 one hot 格式 "10001001"，其中index查 o_gov_code
function ConvertToOneHotFormat(q_meta: SpwkMetaData, opt_meta_list: SpwkMetaData[]): string {

  //#region 取得最大的 index 用來新增 Array (並確保都有設定 index)
  let max_idx: number = -1;
  for (const opt_meta of opt_meta_list) {
    let code = opt_meta.o_gov_code;
    let n = parseInt(code);
    if (isNaN(n)) {
      throw new_ErrorAlert("4341686 申報選項必須有 o_gov_code 且為數字 !!!\nopt_meta.data_guid: " + opt_meta.data_guid);
    }

    if (n > max_idx) {
      max_idx = n;
    }
  }
  //#endregion
  var check_arry = new Array((max_idx + 1)).fill("0");
  if (q_meta.kind === SpwkUtilV3.Q_KIND_多選) {
    for (const opt_meta of opt_meta_list) {
      if (opt_meta.rhf_value === true) {
        let idx = parseInt(opt_meta.o_gov_code);
        check_arry[idx] = "1";
      }
    }
  } else if (q_meta.kind === SpwkUtilV3.Q_KIND_單選) {

    let rhf_value = q_meta.rhf_value ?? "";
    let find_opt = opt_meta_list.find(x => x.code === rhf_value);

    if (find_opt != null) {
      let idx = parseInt(find_opt.o_gov_code);
      check_arry[idx] = "1";
    }
  } else {
    if (q_meta.func_code === "A98") {

    } else {
      throw new_ErrorAlert("484316 申報 通用問題 必須是 多選 或 單選 !!!\nq_meta.data_guid= " + q_meta.data_guid);

    }
  }

  return check_arry.join("");

}

export function A98申報解碼(q_meta: SpwkMetaData, 基本檔: HisBasic, step: SpwkGovStep, meta_table: SpwkMetaTable): GovRow {
  const gov_row: GovRow = new GovRow(基本檔, step.Gov問卷類別);
  gov_row.問題編號 = q_meta.q_gov_code;
  /* 填寫勾選 OneHot 格式 */
  let opt_meta_list = meta_table.FilterOptions_ByQuestionGuid(q_meta.question_guid);
  let one_hot_value = ConvertToOneHotFormat(q_meta, opt_meta_list);
  gov_row.答題內容 = one_hot_value; // "010010"


  /* 填寫 TextBox */
  填寫申報文字答題1到4(gov_row, q_meta, meta_table);
  if (gov_row.問題編號.startsWith('03')) {
    let re = gov_row.答題內容.split('')
    let inp: string = ''
    if (gov_row.答題內容_1) {
      re[0] = "1"
    }
    if (gov_row.答題內容_2) {
      re[1] = "1"
    }
    inp = re.toString().replace(/,/g, '');
    gov_row.答題內容 = inp
  }
  return gov_row;
}
